module.exports = __webpack_public_path__ + "img/allow_children.206f0303.svg";